<section>
  <div class="title first">User Preferences</div>
  <sm-profile-preferences class="section"></sm-profile-preferences>
  <sm-profile-key-storage></sm-profile-key-storage>
</section>
